<template>
    <div class="app-container">
        <el-tabs v-model="activeTabName" type="card" @tab-remove="removeTab">
            <el-tab-pane :label="$t('order.list')" :name="listTab.tabName" :key="listTab.tabName">
                <el-form role="form" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item :label="$t('base.company.name')">
                                <el-select @change="changeCompany" clearable v-model="listQuery.companyId" @clear="clearEmpty('companyId')" :style="{width:'100%'}">
                                    <el-option
                                            v-for="item in companyList"
                                            :value="item.companyId"
                                            :key="item.companyId"
                                            :label="item.companyName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('base.project.name')">
                                <el-select :disabled="ableProject" clearable v-model="listQuery.projectId" :style="{width:'100%'}">
                                    <el-option
                                            v-for="item in projectList"
                                            :value="item.projectId"
                                            :key="item.projectId"
                                            :label="item.projectName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('order.declareDept')">
                                <el-select :disabled="ableDepartment" clearable v-model="listQuery.reportDeptId" :style="{width:'100%'}">
                                    <el-option
                                            v-for="item in departmentList"
                                            :value="item.deptId"
                                            :key="item.deptId"
                                            :label="item.deptName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('base.dept.responsibleDept')">
                                <el-select :disabled="ableDepartment" clearable v-model="listQuery.resDeptId" :style="{width:'100%'}">
                                    <el-option
                                            v-for="item in departmentList"
                                            :value="item.deptId"
                                            :key="item.deptId"
                                            :label="item.deptName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item :label="$t('order.declarePeople')">
                                <el-select v-model="listQuery.reportUserId" clearable :style="{width:'100%'}">
                                    <el-option
                                            v-for="item in employeeList"
                                            :value="item.userId"
                                            :key="item.userId"
                                            :label="item.userName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('base.dept.responsiblePerson')">
                                <el-select v-model="listQuery.handlePerson" clearable :style="{width:'100%'}">
                                    <el-option
                                            v-for="item in employeeList"
                                            :value="item.userId"
                                            :key="item.userId"
                                            :label="item.userName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('order.level')">
                                <el-select v-model="listQuery.orderLevel" clearable :style="{width:'100%'}">
                                    <el-option value="0" :label="$t('order.config.ordinary')"></el-option>
                                    <el-option value="1" :label="$t('order.config.urgent')"></el-option>
                                    <el-option value="2" :label="$t('order.config.alarm')"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('order.status')">
                                <el-select v-model="listQuery.orderStatus" clearable :style="{width:'100%'}">
                                    <el-option value="6" :label="$t('order.declareCheckFailure')"></el-option>
                                    <el-option value="1" :label="$t('order.waitReceive')"></el-option>
                                    <el-option value="2" :label="$t('order.waitExecute')"></el-option>
                                    <el-option value="3" :label="$t('order.executing')"></el-option>
                                    <el-option value="4" :label="$t('order.completedWaitCheck')"></el-option>
                                    <el-option value="5" :label="$t('order.completed')"></el-option>
                                    <el-option value="7" :label="$t('order.completeCheckFailure')"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item :label="$t('base.device.position')">
                                <tree-select
                                        v-model="listQuery.positionId"
                                        :miltiple="false"
                                        :show-count="true"
                                        :placeholder="$t('commons.selectPlease')"
                                        :options="editPositionList"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('base.device.name')">
                                <el-input v-model="listQuery.deviceName" maxlength="25" clearable @keyup.enter.native="getOrderPage"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('commons.startTime')">
                                <el-date-picker
                                        @change="pickerStart"
                                        v-model="listQuery.reportStartDate"
                                        type="date"
                                        style="width: 100%"
                                        format="yyyy-MM-dd"
                                        :placeholder="$t('commons.startTime')">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label="$t('commons.endTime')">
                                <el-date-picker
                                        @change="pickerEnd"
                                        v-model="listQuery.reportEndDate"
                                        type="date"
                                        style="width: 100%"
                                        format="yyyy-MM-dd"
                                        :placeholder="$t('commons.endTime')">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item :label="$t('order.orderType')">
                                <el-select v-model="listQuery.orderType" clearable :style="{width:'100%'}">
                                    <el-option value="1" :label="$t('order.device')"></el-option>
                                    <el-option value="2" :label="$t('order.fireSafety')"></el-option>
                                    <el-option value="3" :label="$t('order.quality')"></el-option>
                                    <el-option value="4" :label="$t('order.other')"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6">
                            <el-form-item :label="$t('order.orderCode')">
                                <el-input v-model="listQuery.orderCode" maxlength="80" clearable @keyup.enter.native="getOrderPage"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="filter-container">
                    <el-button type="primary" icon="el-icon-search" :loading="loading" @click="searchWithCon">{{$t('commons.search')}}</el-button>
                    <el-button type="primary" icon="el-icon-brush" plain @click="clearForm">{{$t('commons.clear')}}</el-button>
                    <el-button type="primary" icon="el-icon-download" plain @click="exportOrder">{{$t('commons.export')}}</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="drawerClick" plain >{{$t('order.place')}}</el-button>
                </div>

                <el-table
                        v-loading="loading"
                        element-loading-text="Loading"
                        :data="list"
                        border
                        fit
                        stripe
                        highlight-current-row>
                    <el-table-column :label="$t('base.project.name')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.projectName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.device.position')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.positionName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.device.name')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.deviceName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.orderCode')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.orderCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.faultDesc')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.problemDesc }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.orderType')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <template v-if="s.row.orderType == 1">
                                <span>{{ $t('order.device') }}</span>
                            </template>
                            <template v-if="s.row.orderType == 2">
                                <span>{{ $t('order.fireSafety') }}</span>
                            </template>
                            <template v-if="s.row.orderType == 3">
                                <span>{{ $t('order.quality') }}</span>
                            </template>
                            <template v-if="s.row.orderType == 4">
                                <span>{{ $t('order.other') }}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.serviceDept')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.resDeptName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.servicePeople')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <template v-if="s.row.handlePersonName != null">
                                <span>{{ s.row.handlePersonName }}</span>
                            </template>
                            <template v-else>
                                <span style="color:#FFC107">{{$t('order.waitReceive')}}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.declareDept')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.submitUserDeptName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.declarePeople')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span>{{ s.row.submitUserName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.status')" :show-overflow-tooltip='true'>
                        <template slot-scope="s">
                            <span v-if="s.row.orderStatus==1">{{$t('order.waitReceive')}}</span>
                            <span v-else-if="s.row.orderStatus==2">{{$t('order.waitExecute')}}</span>
                            <span v-else-if="s.row.orderStatus==3">{{$t('order.executing')}}</span>
                            <span v-else-if="s.row.orderStatus==4">{{$t('order.completedWaitCheck')}}</span>
                            <span v-else-if="s.row.orderStatus==5">{{$t('order.completed')}}</span>
                            <span v-else-if="s.row.orderStatus==6">{{$t('order.declareCheckFailure')}}</span>
                            <span v-else-if="s.row.orderStatus==7">{{$t('order.completeCheckFailure')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('order.declareTime')" width="160">
                        <template slot-scope="s">
                            <span>{{ s.row.creationDate | dateFormat('YYYY-MM-DD HH:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('commons.details')" align="center" width="80">
                        <template slot-scope="s">
                            <el-tooltip :content="$t('commons.details')" placeman="bottom">
                                <el-button
                                        @click="showOrderDetail(s.row.orderId)"
                                        circle
                                        type="success"
                                        icon="el-icon-tickets"
                                        size="mini">
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.current"
                            :limit.sync="listQuery.rowCount"
                            @pagination="getOrderPage"/>
            </el-tab-pane>
            <el-tab-pane v-if="detailTab" :label="$t('order.details')" :name="detailTab.tabName" :key="detailTab.tabName" closable>
                <order-detail v-bind:orderRow="order" :key="order.orderId"></order-detail>
            </el-tab-pane>
        </el-tabs>

        <order-fill :orderFillDialog="orderFillDialog" :isToolBar="false" />
    </div>
</template>

<script>
    import{
        getOrderPage,
        getCompanyList,
        getProjectList,
        getResDeptName,
        getEmployeeList,
        getPosition,
        exportOrder
    }from '@/api/business/order/tenant/order'
    import store from '@/store/index'
    import {listToTree} from '@/utils/tree'
    import Pagination from '@/components/Pagination'
    import TreeSelect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import OrderDetail from '@/views/business/order/orderQuery/order/tenant/orderDetail'
    import OrderFill from '@/components/OrderFill'

    const defineTab = {
        listTab : {
            tabName: "1",
        },
        detailTab :  {
            tabName: "2",
        },
    }

    export default {
        name: "orderManager",
        components:{Pagination,TreeSelect,OrderDetail,OrderFill},
        data(){
            return{
                orderFillDialog: false,
                activeTabName : defineTab.listTab.tabName,
                detailTab : null,
                loading: true,
                isBorder:true,
                ableProject:true,
                ableDepartment:true,
                total:0,
                list:null,
                data:[],
                companyList:[],
                projectList:[],
                departmentList:[],
                employeeList:[],
                editPositionList:[],
                listQuery:{
                    current:1,
                    rowCount:10,
                    orderType:null,
                    companyId:null,
                    projectId:null,
                    positionId:null,
                    deviceName:null,
                    reportStartDate:null,
                    reportEndDate:null,
                    resDeptId:null,
                    handlePerson:null,
                    reportDeptId:null,
                    reportUserId:null,
                    orderLevel:null,
                    orderStatus:null,
                    orderCode:null,
                },
                order: {
                    orderId: null,
                },
            }
        },
        created(){
            this.searchWithCon()
            this.getCompanyList()
            this.getPosition()
            this.getEmployeeList()
        },
        computed: {
            listTab() {
                return defineTab.listTab;
            }
        },
        methods:{
            // 关闭项Tab
            removeTab(tabName) {
                this.activeTabName = defineTab.listTab.tabName;
                if(tabName == "2") {
                    this.detailTab = null;
                }
            },
            // 展示工单详情
            showOrderDetail(orderId){
                // 打开tab
                this.detailTab = defineTab.detailTab;
                this.order.orderId = orderId;
                this.activeTabName = defineTab.detailTab.tabName;
            },
            pickerStart(start){
                this.listQuery.reportStartDate = start.getTime()
            },
            pickerEnd(end){
                this.listQuery.reportEndDate = end.getTime()
            },
            //设备工单列表
            getOrderPage(){
                this.loading = true;
                if(!this.listQuery.deviceName){
                    this.listQuery.deviceName = null;
                }
                getOrderPage(this.listQuery).then(res=>{
                    this.list = res.rows;
                    this.total = res.total;
                }).finally(() => {
                    this.loading = false;
                })
            },
            //加载公司列表
            getCompanyList(){
                getCompanyList().then(res=>{
                    this.companyList = res;
                })
            },
            //清除
            clearForm(){
                this.listQuery.orderType = '';
                this.listQuery.companyId = '';
                this.listQuery.projectId = '';
                this.listQuery.positionId = null;
                this.listQuery.deviceName = '';
                this.listQuery.reportStartDate = '';
                this.listQuery.reportEndDate = '';
                this.listQuery.resDeptId = '';
                this.listQuery.handlePerson = '';
                this.listQuery.reportDeptId = '';
                this.listQuery.reportUserId = '';
                this.listQuery.orderLevel = '';
                this.listQuery.orderStatus = '';
            },
            //查询
            searchWithCon(){
                this.listQuery.current = 1;
                this.getOrderPage()
            },
            //切换公司
            changeCompany(companyId){
                if(companyId){
                    this.ableDepartment = false;
                    this.ableProject = false;
                    this.listQuery.projectId = null;
                    this.listQuery.resDeptId = null;
                    this.listQuery.reportDeptId = null;
                    getProjectList({"companyId":companyId}).then(res=>{
                        this.projectList = res;
                    })
                    getResDeptName({"companyId":companyId}).then(resu=>{
                        this.departmentList = resu;
                    })
                }else{
                    this.departmentList = [];
                    this.projectList = [];
                    this.listQuery.projectId = null;
                    this.listQuery.resDeptId = null;
                    this.listQuery.reportDeptId = null;
                    this.ableDepartment = true;
                    this.ableProject = true;
                }
            },
            //加载维修人员列表
            getEmployeeList(){
                getEmployeeList().then(res=>{
                    this.employeeList = res;
                })
            },
            getPosition(){
                getPosition().then(res=>{
                    let data = listToTree(res,"positionId","parentId");
                    this.recursivePosition(data)
                })
            },
            recursivePosition(row){
                let data = row.map(v=>{
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children)
                    }
                    return v
                })
                this.editPositionList = data;
            },
            exportOrder(){
                exportOrder(this.listQuery).then((msg)=>{
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    let exportObj = {
                        taskId : msg,
                        taskName : "Order",
                        taskStatus : 0,
                        rootPath : 'basePath'
                    };
                    //将导出任务丢入导出任务列表中
                    store.dispatch('PushExportTaskList',exportObj);
                })
            },
            clearEmpty(field) {
                this.listQuery[field] = null
            },
            drawerClick(){
                this.orderFillDialog = true;
            }
        }
    }
</script>
